// extracted by mini-css-extract-plugin
module.exports = {"root":"root-2KB9Q_dbiJ","centered":"centered-1OW4fBcLgC"};